module.exports = __webpack_public_path__ + "static/media/file-pdf.75db9f10.svg";